<template>
  <div style="margin: 4px 16px 16px;">
    <div class="content-input" style="margin-bottom: 8px;">
      <div class="content-input-left">
        <div class="dialog-input-item">
          <DatePickerRange :title="pageType ==1?'充值时间':'抵扣时间'" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
        </div>
        <div class="dialog-input-item" v-if="pageType ==1">
          <label>充值账户</label>
          <el-select v-model="balanceType" placeholder="Select" class="select-item">
            <el-option v-for="item in balanceTypeArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="dialog-input-item" v-if="pageType ==1">
          <label>充值门店</label>
          <el-select v-model="shopId" placeholder="Select" class="select-item">
            <el-option v-for="item in shopIdArray" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="dialog-input-item">
          <label>负责人</label>
          <el-input type="text" v-model="searchValue" placeholder="请输入负责人" class="select-item"  clearable>
            <template #prefix>
              <el-icon class="el-input__icon"><ElIcons name="search" /></el-icon>
            </template>
          </el-input>
        </div>
      </div>
      <div class="content-input-right">
        <div class="dialog-input-btn">
          <ElButtons  type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPage(true)"> 查询 </ElButtons>
        </div>
      </div>
    </div>
    <el-table
        ref="multipleTableRef"
        :data="pageDataList"
        style="width: 100%; "
        v-loading="listLoading"
        size="default"
        border
    >
      <!--            <el-table-column property="id" label="ID" v-if="checkColList.indexOf('ID') > -1"/>-->
      <el-table-column property="createTime" label="时间" width="200"/>
      <el-table-column property="shopName" label="充值门店" width="200" v-if="pageType ==1"/>
      <el-table-column property="content" label="充值记录" v-if="pageType ==1"/>
      <el-table-column property="content" label="抵扣记录" v-if="pageType ==2"/>
      <el-table-column property="relationAdminName" label="负责人" width="200"/>
    </el-table>
    <!--分页-->
    <el-pagination background @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="totalRow" style="text-align:right;margin-top: 24px;">
    </el-pagination>
  </div>
</template>

<script>
import { getFormData } from '@/api/api';
import {getAllShopList, getWalletPageList, getRecordShops} from '@/api/url';
// import Dialog from '@/assets/js/dialog'
// import AddUserRemarkDialog from './AddUserRemarkDialog';
import DatePickerRange from "@/components/DatePickerRange";
export default {
  props: {
    value: Object
  },
  components: {DatePickerRange},
  data() {
    return {
      pageDataList: [],
      id: this.value.id,
      pageType: this.value.pageType,
      totalRow: 0,
      pageSize: 20,
      currentPage: 1,
      listLoading: false,
      searchLoading: false,

      //时间
      startTime: '',
      endTime: '',
      isChecked: true,

      searchValue: '',
      searchType: 1,

      balanceType: -1,
      balanceTypeArray: [
        {label: '不限', value: -1},
        {label: '500账户', value: 1},
        {label: '1000账户', value: 2},
        {label: '1500账户', value: 3},
        {label: '2500账户', value: 4}
      ],

      shopIdArray: [],
      shopIdArr:[],
      shopId: 0,

    }
  },
  methods: {

    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },
    getCheck(val) {
      this.isChecked = val
    },

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['userId'] = this.id;
      param['balanceType'] = this.balanceType;
      param['pageType'] = this.pageType;
      param['shopId'] = this.shopId;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['searchType'] = this.searchType;
      param['searchValue'] = this.searchValue;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getWalletPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.pageDataList.sort(this.compare)
          this.totalRow = result['total'];
          this.pageSize = result['size'];
          if(this.pageDataList.length > 3) {
            sessionStorage.setItem('userLog', JSON.stringify(this.pageDataList.slice(0,3)));
          } else {
            sessionStorage.setItem('userLog', JSON.stringify(this.pageDataList));
          }
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    getShopList() {
      let param = {}
      param['userId'] = this.id
      param['type'] = 3
      getFormData(getRecordShops, param).then(data=> {
        data.data.map((item) => {
          this.shopIdArr.push(item)
        })
        this.shopIdArray = this.shopIdArray.concat(this.shopIdArr)
      })
    }

  },
  mounted() {
    this.getShopList()
    this.getPage();
  }
}
</script>

<style>

</style>
